import { render, staticRenderFns } from "./NovaEmpresa.vue?vue&type=template&id=6bd3c20b&"
import script from "./NovaEmpresa.vue?vue&type=script&lang=js&"
export * from "./NovaEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports